nc_initSeoNavigation('.seo-navigation_wrapper', '.seo-navigation_label', '.seo-navigation_close-icon');